import { Injectable } from '@angular/core';
import { AdyenPaymentDisplayResult, AdyenProcessResult } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AdyenResultService {
  processAdyenResult(result: AdyenPaymentDisplayResult): AdyenProcessResult {
    switch (result.result) {
      case 'SUCCESS':
        return {
          status: 'success',
          orderCode: result.orderCode,
          eligibleForDonation: result.eligibleForDonation,
          messageKey: 'checkout.payment.success.description'
        };
      case 'VALIDATION_PENDING':
        return {
          status: 'pending',
          orderCode: result.orderCode,
          messageKey: 'checkout.payment.success.description'
        };
      case 'FAIL':
        return {
          status: 'fail',
          orderCode: result.orderCode,
          toastTitleKey: 'checkout.payment.toasts.error.title',
          messageKey: 'checkout.payment.toasts.error.description'
        };
      case 'ACTION':
        return {
          status: 'action',
          orderCode: result.orderCode,
          action: JSON.parse(result.action),
          toastTitleKey: 'checkout.payment.toasts.error.title',
          messageKey: 'checkout.payment.toasts.error.description'
        };
      default:
        return {
          status: 'fail',
          orderCode: result.orderCode,
          messageKey: 'checkout.payment.toasts.error.description'
        };
    }
  }
}
